import React from 'react';
import { ListItem, ListItemContent } from "@mui/joy";
import { Button } from '../Button';

import { useTranslation } from 'react-i18next'

const RelationshipSimple = ({ k, v, editing, handleItemDetail, handleItemRemove }) => {
    const { t, i18n } = useTranslation();

    return (
        <ListItem k={k} variant="outlined" className={"relationship-element"}>
            <ListItemContent className={"relationship-element-content"}>
                {v?.name}
            </ListItemContent>
            
            {editing && (<Button onClick={() => handleItemDetail(v)} icon="faPen" variant="plain" />)}
            {(editing && handleItemRemove) && (<Button onClick={() => handleItemRemove(v)} icon="faClose" variant="plain" />)}
        </ListItem>
    )
}

export default RelationshipSimple



